/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CidDataResponse,
} from '../models';
import {
    CidDataResponseFromJSON,
    CidDataResponseToJSON,
} from '../models';

export interface GetMetadataRequest {
    metadataId: string;
}

/**
 * 
 */
export class CidDataApi extends runtime.BaseAPI {

    /**
     * @hidden
     * Get a metadata by CID
     */
    async getMetadataRaw(params: GetMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CidDataResponse>> {
        if (params.metadataId === null || params.metadataId === undefined) {
            throw new runtime.RequiredError('metadataId','Required parameter params.metadataId was null or undefined when calling getMetadata.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/cid_data/{metadata_id}`.replace(`{${"metadata_id"}}`, encodeURIComponent(String(params.metadataId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CidDataResponseFromJSON(jsonValue));
    }

    /**
     * Get a metadata by CID
     */
    async getMetadata(params: GetMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CidDataResponse> {
        const response = await this.getMetadataRaw(params, initOverrides);
        return await response.value();
    }

}
